import {
	BrowserClient,
	defaultStackParser,
	makeFetchTransport,
	breadcrumbsIntegration,
	dedupeIntegration,
	globalHandlersIntegration,
	linkedErrorsIntegration,
	browserSessionIntegration,
	getCurrentScope,
} from "@sentry/react";

if (process.env.SENTRY_DSN) {
	const client = new BrowserClient({
		dsn: process.env.SENTRY_DSN,
		environment: process.env.SENTRY_ENVIRONMENT ?? "development",
		release: process.env.SENTRY_RELEASE,
		transport: makeFetchTransport,
		stackParser: defaultStackParser,
		integrations: [
			breadcrumbsIntegration(),
			globalHandlersIntegration(),
			linkedErrorsIntegration(),
			dedupeIntegration(),
			browserSessionIntegration({ lifecycle: "page" }),
		],
	});

	getCurrentScope().setClient(client);
	client.init();
}
